import { render, staticRenderFns } from "./TotalToday.vue?vue&type=template&id=451fa414&"
import script from "./TotalToday.vue?vue&type=script&lang=js&"
export * from "./TotalToday.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports